module.exports = __webpack_public_path__ + "static/media/IMG_8708.b60a942d.JPG";